module.exports = __webpack_public_path__ + "images/emoji/disappointed_relieved.a410a833c38484d7f790.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/disappointed_relieved.png
// module id = ndnp
// module chunks = 2